import { displayElem } from '../functions/displayElem';
import { updateText } from '../functions/updateText';

export const handle404 = next => async ({ directive, meta, error, tries, resolved }) => {

  // Handle 404 not found!
  if (!resolved && error.status === 404) {
    updateText('#feedback', "VIDEO HAS EXPIRED OR BEEN REMOVED");
    displayElem('#loadingOverlay', 'none');
    displayElem('#passwordForm', 'inline-block');
    resolved = true;
  }

  return next({ directive, meta, error, tries, resolved });
};
